module.exports = __webpack_public_path__ + "img/BRI.12e35748.png";